import axios from './axios'
import config from '../config'

export default {
    listPageTemplates(params) {
        return axios({
            url: config.backendUrl + '/common/page-templates',
            method: 'GET',
            params
        })
    },
    addPageTemplate(data) {
        return axios({
            url: config.backendUrl + '/common/page-templates',
            method: 'POST',
            data
        })
    },
    updatePageTemplate(data) {
        return axios({
            url: config.backendUrl + '/common/page-templates',
            method: 'PUT',
            data
        })
    },
    updatePageTemplatePageConfig(id, data) {
        return axios({
            url: config.backendUrl + '/common/page-templates/' + id + '/page-config',
            method: 'PUT',
            data
        })
    },
    getPageTemplate(id) {
        return axios({
            url: config.backendUrl + '/common/page-templates/' + id,
            method: 'GET'
        })
    },
    deletePageTemplate(id) {
        return axios({
            url: config.backendUrl + '/common/page-templates/' + id,
            method: 'DELETE'
        })
    }
}
